import React from 'react';
import { Filter, Building2, Grid3x3, MapPin } from 'lucide-react';

export default function FilterPanel({ 
  categories, 
  halls, 
  selectedCategory, 
  selectedHall, 
  onCategoryChange, 
  onHallChange,
  boothStats 
}) {
  return (
    <div className="bg-slate-900/70 backdrop-blur-xl rounded-2xl p-4 border border-slate-700/50 shadow-xl" data-testid="filter-panel">
      <div className="flex items-center gap-2 mb-4">
        <Filter className="w-4 h-4 text-blue-400" />
        <h3 className="text-sm font-bold text-white uppercase tracking-wider">Filters</h3>
      </div>

      {/* Stats */}
      {boothStats && (
        <div className="grid grid-cols-3 gap-2 mb-4">
          <div className="bg-slate-800/50 rounded-lg p-2 text-center border border-slate-700/30">
            <div className="text-xl font-black text-white">{boothStats.total_booths || 0}</div>
            <div className="text-[10px] text-slate-400 uppercase">Total</div>
          </div>
          <div className="bg-emerald-500/10 rounded-lg p-2 text-center border border-emerald-500/30">
            <div className="text-xl font-black text-emerald-400">{boothStats.occupied_booths || 0}</div>
            <div className="text-[10px] text-emerald-400 uppercase">Occupied</div>
          </div>
          <div className="bg-slate-500/10 rounded-lg p-2 text-center border border-slate-500/30">
            <div className="text-xl font-black text-slate-300">{boothStats.available_booths || 0}</div>
            <div className="text-[10px] text-slate-400 uppercase">Available</div>
          </div>
        </div>
      )}

      {/* Halls filter */}
      <div className="mb-4">
        <div className="flex items-center gap-2 mb-2">
          <MapPin className="w-3.5 h-3.5 text-purple-400" />
          <label className="text-xs font-semibold text-slate-300 uppercase">Zone</label>
        </div>
        <div className="grid grid-cols-2 gap-2">
          <button
            onClick={() => onHallChange(null)}
            className={`px-3 py-2 rounded-lg text-xs font-medium transition-all ${
              !selectedHall 
                ? 'bg-blue-500 text-white shadow-lg shadow-blue-500/30' 
                : 'bg-slate-800/50 text-slate-300 hover:bg-slate-800 border border-slate-700/50'
            }`}
            data-testid="filter-hall-all"
          >
            All Zones
          </button>
          {halls.map((hall) => (
            <button
              key={hall.id}
              onClick={() => onHallChange(hall.id)}
              className={`px-3 py-2 rounded-lg text-xs font-medium transition-all truncate ${
                selectedHall === hall.id 
                  ? 'bg-blue-500 text-white shadow-lg shadow-blue-500/30' 
                  : 'bg-slate-800/50 text-slate-300 hover:bg-slate-800 border border-slate-700/50'
              }`}
              data-testid={`filter-hall-${hall.id}`}
            >
              {hall.name.split(' - ')[0]}
            </button>
          ))}
        </div>
      </div>

      {/* Categories filter */}
      <div>
        <div className="flex items-center gap-2 mb-2">
          <Grid3x3 className="w-3.5 h-3.5 text-emerald-400" />
          <label className="text-xs font-semibold text-slate-300 uppercase">Category</label>
        </div>
        <div className="max-h-40 overflow-y-auto space-y-1 pr-1">
          <button
            onClick={() => onCategoryChange(null)}
            className={`w-full flex items-center gap-2 px-3 py-2 rounded-lg text-xs font-medium transition-all ${
              !selectedCategory 
                ? 'bg-emerald-500 text-white' 
                : 'bg-slate-800/50 text-slate-300 hover:bg-slate-800 border border-slate-700/50'
            }`}
            data-testid="filter-category-all"
          >
            All Categories
          </button>
          {categories.map((cat) => (
            <button
              key={cat.id}
              onClick={() => onCategoryChange(cat.id)}
              className={`w-full flex items-center gap-2 px-3 py-2 rounded-lg text-xs font-medium transition-all ${
                selectedCategory === cat.id 
                  ? 'text-white shadow-lg' 
                  : 'bg-slate-800/50 text-slate-300 hover:bg-slate-800 border border-slate-700/50'
              }`}
              style={selectedCategory === cat.id ? { backgroundColor: cat.color } : {}}
              data-testid={`filter-category-${cat.id}`}
            >
              <span className="text-base">{cat.icon}</span>
              <span className="flex-1 text-left truncate">{cat.name}</span>
              {cat.booths_count !== undefined && (
                <span className="text-[10px] opacity-70">{cat.booths_count}</span>
              )}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
